import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import { joinWithCommasAndAnd } from '~/helpers'

const AlertBrandsPureComponent: React.FC<AlertBrandsPureComponentProps> = ({
  publisherBrands = []
}) => {
  return (
    <>
      {!!publisherBrands?.length && (
        <Alert
          variant="informational"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <p className="mb-0">
            {t('rm:publisher.multiple.brands.message')}{' '}
            <strong>
              {joinWithCommasAndAnd({
                values: publisherBrands?.map(({ name }) => name)
              })}
            </strong>
            .
          </p>
        </Alert>
      )}
    </>
  )
}

export default AlertBrandsPureComponent
